import React from "react";
import "./doctors.css";
import { useNavigate } from 'react-router-dom';


function DoctorsProfiles() {
    const navigate = useNavigate();

  const doctors = [
    {
      name: "Dr. Dissanayake",
      title: "Chief Ayurvedic Practitioner",
      image: "/dr-dissanayake.png",
      bio: "With over 25 years of dedicated practice in Ayurvedic medicine, Dr. Disanayake specializes in traditional therapeutic massage (Abhyanga), Panchakarma detoxification, and chronic disease management. He has successfully treated over 10,000 patients with various ailments including arthritis, digestive disorders, and stress-related conditions. His holistic approach combines ancient wisdom with modern diagnostic techniques.",
      expertise: [
        "Panchakarma Therapy",
        "Chronic Disease Management",
        "Ayurvedic Nutrition",
        "Herbal Medicine"
      ],

    },
    {
      name: "Dr. Srimal Madushanka",
      title: "Senior Ayurvedic Practitioner",
      image: "/dr-srimal.png",
      bio: "Dr. Srimal Madushanka brings 15 years of expertise in traditional Ayurvedic medicine, specializing in therapeutic massage, wellness coaching, and preventive healthcare. He is renowned for his expertise in Marma therapy, Shirodhara treatments, and personalized wellness protocols. Dr. Madushanka has trained under renowned Ayurvedic masters in Kerala and has conducted numerous workshops on stress management and lifestyle modification.",
      expertise: [
        "Marma Therapy",
        "Shirodhara Treatment",
        "Wellness Coaching",
        "Preventive Healthcare"
      ],

    },
  ];

  return (
    <>
    
    
 {/* Hero Section with banner.png from public folder - USING INLINE STYLE WITH PUBLIC PATH */}
      <section 
        className="treatments-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(46,125,50,0.9), rgba(0,0,0,0.7)), url('/footer banner.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1 className="hero-title">
            OUR <span>DOCTORS</span>
          </h1>
          <p className="hero-description">
             Experienced practitioners dedicated to your wellness journey with traditional healing wisdom
          </p>
        </div>
      </section>
    
    
    
 
    <div className="doctors-section">








      {/* Decorative Elements */}
      <div className="leaf-decoration leaf-1"></div>
      <div className="leaf-decoration leaf-2"></div>
      
      <div className="section-header">
        <h2 className="doctors-title">
          Meet Our Ayurvedic Doctors
        </h2>
        <div className="title-underline"></div>

      </div>
      
      <div className="doctors-grid">
        {doctors.map((doctor, index) => (
          <div key={index} className="doctor-card">
            {/* Card Header with Pattern */}
            <div className="card-pattern"></div>
            
            {/* Image Section */}
            <div className="doctor-image-container">
              <div className="image-frame">
                <div className="image-ring"></div>
                <div className="doctor-image">
                  <img src={doctor.image} alt={doctor.name} />
                </div>
              </div>
              
             </div>
            
            {/* Content Section */}
            <div className="doctor-content">
  
              {/* Doctor Info */}
              <h3 className="doctor-name">{doctor.name}</h3>
              <p className="doctor-title">{doctor.title}</p>
              
     
              
              {/* Bio with Read More */}
              <p className="doctor-bio">{doctor.bio}</p>
              
              {/* Expertise Section */}
              <div className="expertise-section">
                <h4>Specializations</h4>
                <div className="expertise-tags">
                  {doctor.expertise.map((item, i) => (
                    <span key={i} className="expertise-tag">{item}</span>
                  ))}
                </div>
              </div>
   

            </div>
            
            {/* Corner Accent */}
            <div className="corner-accent"></div>
          </div>
        ))}
      </div>



            {/* ==================== FINAL CTA ==================== */}
      <section className="doctor-final-cta">
        <div className="doctor-profile-cta-container">
          <h2>Ready to Transform Your Life?</h2>
          <p className="doctor-p-cta-text">Begin your journey to lasting wellness and inner peace today.</p>
          <button className="btn-primary-large-doctor" onClick={() => navigate('/booking')}>
            Reserve Your Place Now
          </button>
        </div>
      </section>



    </div>


       </>
  );
}

export default DoctorsProfiles;